import * as tslib_1 from "tslib";
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { environment } from '../../environment';
import { ESRI } from '../../esri-loader-util';
import { InputConverter } from '../../inputConverter';
import { LayerService } from '../../services/layer.service';
import { LogLevel } from '../../types';
import { BaseComponent } from '../base.component';
var Graphic;
var RouteParameters;
var FeatureSet;
var TextSymbol;
/* tslint:disable:angular-whitespace */
var RoutingComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RoutingComponent, _super);
    function RoutingComponent(_vcr, changeDetectorRef, layerService, loggingService) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.layerService = layerService;
        _this.loggingService = loggingService;
        _this.unit = 'Miles';
        _this.hideCreateLayerButton = false;
        _this.hideStartOverButton = false;
        _this.hideDirections = false;
        _this.routeComplete = new EventEmitter();
        _this.units = ['Miles', 'Kilometers', 'Feet', 'Meters', 'Yards', 'Nautical Miles'];
        _this.barrierUrl = environment.apiBaseUrl + "/assets/images/barrier.png";
        _this.AddingType = 'stop';
        _this._active = false;
        _this.activate = function () {
            _this._active = true;
            if (!_this.routingEventHandler) {
                _this.routingEventHandler = _this.mapView.on('click', _this.clickHandler.bind(_this));
            }
        };
        _this.deactivate = function () {
            _this._active = false;
            if (_this.routingEventHandler) {
                _this.routingEventHandler.remove();
                _this.routingEventHandler = undefined;
            }
            _this.startOver();
        };
        _this.addExternalGraphic = function (type, geometry, symbol) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        geometry.spatialReference = this.mapView.spatialReference;
                        if (!(type === 'stop')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.addGraphic(geometry, this.stopSymbol, type)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(type === 'barrier')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.addGraphic(geometry, this.barrierSymbol, type)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.addGraphic(geometry, symbol, type)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Object.defineProperty(RoutingComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            this._active = value;
            value ? this.activate() : this.deactivate();
        },
        enumerable: true,
        configurable: true
    });
    RoutingComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, error_1;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 5, 6, 7]);
                        _b = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _b.mapView = _e.sent();
                        return [4 /*yield*/, Promise.all([
                                ESRI.Graphic,
                                ESRI.RouteParameters,
                                ESRI.FeatureSet,
                                ESRI.TextSymbol
                            ])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_e.sent(), 4]), Graphic = _a[0], RouteParameters = _a[1], FeatureSet = _a[2], TextSymbol = _a[3];
                        _c = this;
                        return [4 /*yield*/, ESRI.route];
                    case 3:
                        _c.route = _e.sent();
                        this.routeUrl = 'https://route-api.arcgis.com/arcgis/rest/services/World/Route/NAServer/Route_World';
                        this.routeParams = new RouteParameters({
                            apiKey: environment.routingApiKey,
                            stops: new FeatureSet(),
                            pointBarriers: new FeatureSet(),
                            polylineBarriers: new FeatureSet(),
                            polygonBarriers: new FeatureSet(),
                            outSpatialReference: this.mapView.spatialReference,
                            returnDirections: true,
                            returnStops: true,
                            returnBarriers: true,
                            returnPolylineBarriers: true,
                            returnPolygonBarriers: true
                        });
                        this.barrierSymbol = {
                            type: 'picture-marker',
                            url: this.barrierUrl,
                            height: '18px',
                            width: '18px'
                        };
                        this.stopSymbol = new TextSymbol({
                            color: 'green',
                            text: '\ue61d',
                            font: {
                                size: 24,
                                family: 'CalciteWebCoreIcons'
                            }
                        });
                        this.routeSymbol = {
                            type: 'simple-line',
                            color: '#0079c1',
                            width: 5
                        };
                        _d = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: 'Routing Highlight', hideInLegend: true })];
                    case 4:
                        _d.routingHighlightLayer = _e.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        error_1 = _e.sent();
                        this.readyProblem(error_1);
                        return [3 /*break*/, 7];
                    case 6:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    RoutingComponent.prototype.clickHandler = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.active) return [3 /*break*/, 4];
                        if (!(this.AddingType === 'stop')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.addGraphic(event.mapPoint, this.stopSymbol, this.AddingType)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(this.AddingType === 'barrier')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.addGraphic(event.mapPoint, this.barrierSymbol, this.AddingType)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RoutingComponent.prototype.addGraphic = function (geometry, symbol, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, error_2, graphic;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.routingLayer) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: 'Routing', hideInLegend: true })];
                    case 2:
                        _a.routingLayer = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        this.loggingService.Log(error_2, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4:
                        this.clearRoutes();
                        this.clearHighlightLayer();
                        graphic = new Graphic({
                            attributes: { Type: type },
                            geometry: geometry,
                            symbol: symbol
                        });
                        this.routingLayer.add(graphic);
                        switch (type) {
                            case 'stop':
                                this.routeParams.stops.features.push(graphic);
                                break;
                            case 'barrier':
                                this.routeParams.pointBarriers.features.push(graphic);
                                break;
                            case 'segment':
                                this.routeParams.polylineBarriers.features.push(graphic);
                                break;
                            case 'area':
                                this.routeParams.polygonBarriers.features.push(graphic);
                                break;
                            default:
                                break;
                        }
                        return [4 /*yield*/, this.solveRoute()];
                    case 5:
                        _b.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    RoutingComponent.prototype.removeGraphic = function (graphic, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var stopFeatures, barrierFeatures, segmentFeatures, areaFeatures;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.routingLayer.remove(graphic);
                        this.clearRoutes();
                        this.clearHighlightLayer();
                        switch (type) {
                            case 'stop':
                                stopFeatures = this.routeParams.stops.features.filter(function (x) { return x !== graphic; });
                                this.routeParams.stops.features = stopFeatures;
                                break;
                            case 'barrier':
                                barrierFeatures = this.routeParams.pointBarriers.features.filter(function (x) { return x !== graphic; });
                                this.routeParams.pointBarriers.features = barrierFeatures;
                                break;
                            case 'segment':
                                segmentFeatures = this.routeParams.polylineBarriers.features.filter(function (x) { return x !== graphic; });
                                this.routeParams.polylineBarriers.features = segmentFeatures;
                                break;
                            case 'area':
                                areaFeatures = this.routeParams.polygonBarriers.feature.filter(function (x) { return x !== graphic; });
                                this.routeParams.polygonBarriers.features = areaFeatures;
                                break;
                            default:
                                break;
                        }
                        return [4 /*yield*/, this.solveRoute()];
                    case 1:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    RoutingComponent.prototype.overGraphic = function (graphic) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layerView;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mapView.whenLayerView(this.routingLayer)];
                    case 1:
                        layerView = _a.sent();
                        this.highlightedGraphic = layerView.highlight(graphic);
                        return [2 /*return*/];
                }
            });
        });
    };
    RoutingComponent.prototype.outGraphic = function () {
        if (this.highlightedGraphic) {
            this.highlightedGraphic.remove();
        }
    };
    RoutingComponent.prototype.drop = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        moveItemInArray(this.routeParams.stops.features, event.previousIndex, event.currentIndex);
                        this.clearRoutes();
                        return [4 /*yield*/, this.solveRoute()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RoutingComponent.prototype.solveRoute = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, routeResult, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!(this.routeParams.stops.features.length >= 2)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.route.solve(this.routeUrl, this.routeParams)];
                    case 1:
                        data = _a.sent();
                        if (data) {
                            routeResult = data.routeResults[0];
                            routeResult.route.symbol = this.routeSymbol;
                            routeResult.route.attributes.Type = 'route';
                            this.result = data;
                            this.directions = routeResult.directions;
                            this.routingLayer.add(routeResult.route);
                            this.distanceInMiles = routeResult.route.attributes.Total_Miles;
                            this.mapView.goTo(routeResult.route.geometry, { animate: true, duration: 1000 });
                            this.unitChange(this.unit);
                        }
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.loggingService.Log(error_3, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RoutingComponent.prototype.zoomToLocation = function (direction) {
        this.highlightSegment(direction);
        this.mapView.goTo(direction.geometry, { animate: true });
    };
    RoutingComponent.prototype.clearHighlightLayer = function () {
        var _this = this;
        if (this.routingHighlightLayer && this.layerService.mapLayers.graphics.filter(function (x) { return x.title === _this.routingHighlightLayer.title; })[0]) {
            this.routingHighlightLayer.removeAll();
        }
    };
    RoutingComponent.prototype.highlightSegment = function (segment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.clearHighlightLayer();
                this.layerService.moveLayerToTheTop(this.routingHighlightLayer);
                this.routingHighlightLayer.add(new Graphic({
                    geometry: segment.geometry,
                    symbol: {
                        type: 'simple-line',
                        color: 'rgba(0, 94, 149, 0.5)',
                        width: 10
                    }
                }));
                return [2 /*return*/];
            });
        });
    };
    RoutingComponent.prototype.startOver = function () {
        this.clearGraphics('stop');
        this.clearGraphics('barrier');
        this.clearGraphics('segment');
        this.clearGraphics('area');
        this.clearRoutes();
        this.clearHighlightLayer();
    };
    RoutingComponent.prototype.clearGraphics = function (type) {
        if (this.routingLayer) {
            var graphics = this.routingLayer.graphics.filter(function (x) { return x.attributes.Type === type; });
            this.routingLayer.removeMany(graphics.toArray());
        }
        if (this.routeParams) {
            switch (type) {
                case 'stop':
                    this.routeParams.stops = new FeatureSet();
                    break;
                case 'barrier':
                    this.routeParams.pointBarriers = new FeatureSet();
                    break;
                case 'segment':
                    this.routeParams.polylineBarriers = new FeatureSet();
                    break;
                case 'area':
                    this.routeParams.polygonBarriers = new FeatureSet();
                    break;
                default:
                    break;
            }
        }
    };
    RoutingComponent.prototype.clearRoutes = function () {
        if (this.routingLayer) {
            var routes = this.routingLayer.graphics.filter(function (x) { return x.attributes.Type === 'route'; });
            this.routingLayer.removeMany(routes.toArray());
        }
        this.result = null;
        this.directions = null;
        this.distance = null;
        this.distanceInMiles = null;
    };
    RoutingComponent.prototype.createLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var routingDetail, newRoutingLayer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRoutingDetail()];
                    case 1:
                        routingDetail = _a.sent();
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: 'Route', symbols: [this.stopSymbol, this.routeSymbol] }, { routingDetail: routingDetail })];
                    case 2:
                        newRoutingLayer = _a.sent();
                        newRoutingLayer.addMany(this.routingLayer.graphics.toArray().filter(function (g) { return g.geometry.type === 'polyline'; }));
                        this.routeComplete.emit(newRoutingLayer);
                        this.startOver();
                        return [2 /*return*/];
                }
            });
        });
    };
    RoutingComponent.prototype.createRoutingDetail = function () {
        var routingDetail = {
            distance: this.distance,
            distanceInMiles: this.distanceInMiles,
            unit: this.unit,
            pointBarriers: { features: [] },
            stops: { features: [] },
            directions: { features: [] }
        };
        if (this.routeParams.stops && this.routeParams.stops.features.length > 0) {
            this.routeParams.stops.features.forEach(function (stop) {
                var tempStop = {
                    geometry: {
                        latitude: stop.geometry.latitude,
                        longitude: stop.geometry.longitude
                    }
                };
                routingDetail.stops.features.push(tempStop);
            });
        }
        if (this.routeParams.pointBarriers) {
            this.routeParams.pointBarriers.features.forEach(function (barrier) {
                var tempBarrier = {
                    geometry: {
                        latitude: barrier.geometry.latitude,
                        longitude: barrier.geometry.longitude
                    },
                    symbol: {
                        url: barrier.symbol.url
                    }
                };
                routingDetail.pointBarriers.features.push(tempBarrier);
            });
        }
        if (this.directions) {
            this.directions.features.forEach(function (direction) {
                var tempDirection = {
                    attributes: {
                        length: direction.attributes.length,
                        lengthInMiles: direction.attributes.lengthInMiles,
                        time: direction.attributes.time,
                        text: direction.attributes.text,
                        ETA: direction.attributes.ETA,
                        arriveTimeUTC: direction.attributes.arriveTimeUTC,
                        maneuverType: direction.attributes.maneuverType
                    }
                };
                routingDetail.directions.features.push(tempDirection);
            });
        }
        return routingDetail;
    };
    RoutingComponent.prototype.unitChange = function (unit) {
        var _this = this;
        this.unit = unit;
        if (this.distanceInMiles) {
            this.distance = this.convertFromMile(this.distanceInMiles, unit);
        }
        if (this.directions && this.directions.features) {
            this.directions.features.forEach(function (direction) {
                if (direction.attributes.length) {
                    if (!direction.attributes.lengthInMiles) {
                        var lengthInMilesProperty = { lengthInMiles: direction.attributes.length };
                        Object.assign(direction.attributes, lengthInMilesProperty);
                    }
                    direction.attributes.length = _this.convertFromMile(direction.attributes.lengthInMiles, unit);
                }
            });
        }
    };
    RoutingComponent.prototype.convertFromMile = function (fromValue, fromUnit) {
        switch (fromUnit.toUpperCase()) {
            case 'MILES':
                return fromValue * 1;
                break;
            case 'KILOMETERS':
                return fromValue * 1.60934;
                break;
            case 'FEET':
                return fromValue * 5280;
                break;
            case 'METERS':
                return fromValue * 1609.34;
                break;
            case 'YARDS':
                return fromValue * 1760;
                break;
            case 'NAUTICAL MILES':
                return fromValue * 0.868976;
                break;
            default:
                break;
        }
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], RoutingComponent.prototype, "active", null);
    return RoutingComponent;
}(BaseComponent));
export { RoutingComponent };
